// Single source of truth cho link tải app Longhousee (DRY).
// Lưu ý: Android package (com.lh.rewards) KHÁC iOS bundleId (com.longhousee.app).
export const APP_LINKS = {
    ios: "https://apps.apple.com/vn/app/longhousee/id6761009345?l=vi",
    android: "https://play.google.com/store/apps/details?id=com.lh.rewards",
    guideVideo: "https://www.youtube.com/shorts/HifBp1V8PJI",
    pageUrl: "https://longhousee.com/tai-app",
    internalPath: "/tai-app", // dùng cho <Link> điều hướng nội bộ
};

// QR trỏ về trang /tai-app → user desktop quét bằng điện thoại để tải.
export const APP_QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=0&data=${encodeURIComponent(
    APP_LINKS.pageUrl
)}`;
